export default {
  setPointsOfInterest (state, payload) {
    state.list = payload
  }
}